import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useMicrorregiaoV2 = ({ microrregioesDisponiveis }) => {
  const [microrregioes, setMicrorregioes] = useState([]);

  useEffect(() => {
    const fetchMicrorregioes = async (signal) => {
      let query = db.microrregiao;

      if (microrregioesDisponiveis) {
        query = query.where("id").anyOf(microrregioesDisponiveis);
      }
      const result = [];
      await query.each((item) => result.push(item));

      if (!signal.aborted) {
        setMicrorregioes(result);
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchMicrorregioes(signal);
    return () => {
      controller.abort();
    };
  }, [microrregioesDisponiveis]);

  const optionMicrorregioes = useMemo(
    () =>
      prepareForOptions(
        (microrregioes || []).sort((a, b) => a.nome.localeCompare(b.nome)),
        ["nome"],
        "id"
      ),
    [microrregioes]
  );

  return {
    optionMicrorregioes,
  };
};

export default useMicrorregiaoV2;
